let seoDescription = document.querySelector('[data-seo-description]');
let seoButton = document.querySelector('[data-seo-btn]');
const initSEO = (expand=false) => {
    seoDescription.classList.remove('collapsed');
    seoDescription.classList.add('normal');
    seoButton.innerHTML = 'Read More';
    const height = seoDescription.offsetHeight;
    seoDescription.style = 'max-height: initial';
    const fullHeight = seoDescription.offsetHeight;
  
    if (height < fullHeight) {
      seoDescription.style = '';
      seoButton.style.display = '';
    } else {
      seoButton.style.display = 'none';
    }
    if (expand) {
      seoDescription.style = '';
      seoButton.style.display = '';
      seoButton.innerHTML = 'Read Less';
      seoDescription.classList.add('collapsed');
    }
    seoDescription.classList.remove('normal');
}

document.addEventListener('DOMContentLoaded', () => {
    if (seoDescription) {
      initSEO();
      window.addEventListener('resize', () => {
        initSEO(seoDescription.classList.contains('collapsed'));
      }, true);
      window.addEventListener('orientationchange', () => {
        initSEO(seoDescription.classList.contains('collapsed'));
      });
      seoButton.addEventListener('click', () => {
        seoDescription.classList.toggle('collapsed');
        if (seoDescription.classList.contains('collapsed'))
          seoButton.innerHTML = 'Read Less';
        else
          seoButton.innerHTML = 'Read More';
      });
    }
  });
